import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['additional'],
  validate (value) {
    const minAge = this.constants.INSURER_MIN_AGE;

    const message = `The minimum age for this type of insurance is ${minAge}.`;

    const birthDate = new UtcDate(value);
    const today = new UtcDate();
    const insurerAgeAtLatestInsuranceStart = today.differenceInYears(birthDate);

    if (insurerAgeAtLatestInsuranceStart < minAge) return message;

    return true;
  },
};
